import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { CustomTimelineVersion } from '@mpt-fo/common/kamona/model/kamonal-model';
import {TimelineModel} from "@mpt-fo/common/shared/models/timeline.model";
import {PasscodeRecoveryStep} from "@app/channels/auth/login/model/forget-passcode";
import {EmailInput, PhoneNumberInput} from "@mpt-fo/common/kamona/components/kamona-input-field/kamona-input-field.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SettingsService} from "@mpt-fo/common/core/services/settings.service";
import {
	KamonaPhoneNumberFieldComponent
} from "@mpt-fo/common/kamona/components/kamona-phone-number-field/kamona-phone-number-field.component";

@Component({
  selector: 'app-phone-number-recovery',
  templateUrl: './phone-number-recovery.component.html',
  styleUrls: ['./phone-number-recovery.component.scss']
})
export class PhoneNumberRecoveryComponent implements OnInit {
	readonly CustomTimelineVersion = CustomTimelineVersion;
	@Input() timelines: TimelineModel [] = [];
	@Output() emitSubmit = new EventEmitter ();
	@Output() emitBack = new EventEmitter ();
	@Input() submitting: boolean;
	@Input() defaultValue: string;
	phoneNumberTimeline: TimelineModel;
	phoneNumber: PhoneNumberInput;
	form: FormGroup;

  constructor(private fb: FormBuilder, private settingsService: SettingsService) { }

  ngOnInit(): void {
  }

  initialize(){
	  this.phoneNumberTimeline = this.settingsService.findTimelineByStep(this.timelines, PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY);
	  const phoneNumber = this.phoneNumberTimeline?.data?.phoneNumber || this.defaultValue;
	  this.buildForm(phoneNumber);
  }

  buildForm(phoneNumber: string){
	  const regex = new RegExp(".{11}");
	  this.phoneNumber = new PhoneNumberInput(phoneNumber, 'Phone Number', true, null, regex);
	  this.form = this.fb.group({
		  phoneNumber: this.phoneNumber.getFormGroupControl(),
	  });
  }


  submit(){
	  if(this.submitting){return;}
	  this.settingsService.markTimelineAsCompleted(this.timelines, PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY);
	  this.settingsService.markNextTimelineAsActive(this.timelines, PasscodeRecoveryStep.PHONE_VERIFICATION);
	  this.saveDataToPhoneNumberTimeline();
	  this.emitSubmit.emit()
  }

  saveDataToPhoneNumberTimeline(){
	  const phoneNumberTimeline = this.settingsService.findTimelineByStep(this.timelines, PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY);
	  if(!phoneNumberTimeline){return;}
	  const phoneNumber = this.form?.value?.phoneNumber;
	  phoneNumberTimeline.data = {phoneNumber};
  }

  goBack(){
	  if(this.submitting){return;}
	  this.emitBack.emit();
  }

}
